import client from "shared/utils/axios-config";
import {
  AllScheduleForm,
  CreateScheduleBatchForm,
  CreateScheduleForm,
  CustomerTable,
  DeleteScheduleForm,
  InstructorAvailability,
  InstructorAvailabilityForm,
  ScheduleClashCheck,
  ScheduleClashCheckForm,
  Schedule,
  ScheduleDetailForm,
  UpdateScheduleForm,
} from "shared/types";
import { CalendarSchedule } from "components/WeeklyCalendar/components/types";

export const searchSchedulesV2 = async (
  form: AllScheduleForm,
): Promise<CalendarSchedule[]> => {
  const res = await client.post(`/v2/schedule/search`, form);
  return res.data.data;
};

export const getScheduleV2Detail = async (
  form: ScheduleDetailForm,
): Promise<Schedule> => {
  const res = await client.get(`/v2/schedule/detail`, { params: form });
  return res.data.data;
};

// Synchronous first-occurrence clash check used to warn-before-create/reschedule.
export const checkScheduleClashesV2 = async (
  form: ScheduleClashCheckForm,
): Promise<ScheduleClashCheck> => {
  const res = await client.get(`/v2/schedule/clash-check`, { params: form });
  return res.data.data;
};

// Read-only preview of instructor-availability rules for a proposed,
// not-yet-saved schedule — powers the proactive time-picker restriction in
// CreateScheduleDrawer/TimeSection instead of only rejecting at save time.
export const getInstructorAvailability = async (
  form: InstructorAvailabilityForm,
): Promise<InstructorAvailability> => {
  const res = await client.post(`/v2/schedule/availability`, form);
  return res.data.data;
};

export const getAvailableCustomersByScheduleV2 = async (
  form: ScheduleDetailForm,
): Promise<CustomerTable[]> => {
  const res = await client.get(
    `/v2/schedule/${form.schedule_id}/${form.occurrence_timestamp}/available-customers`,
  );
  return res.data.data;
};

export const createScheduleV2 = async (form: CreateScheduleForm) => {
  const res = await client.post(`/v2/schedule/`, form);
  return res.data;
};

// Creates every series in one transaction (all commit or none). Used by the
// per-day-times weekly recurrence, which emits one series per distinct time.
export const createScheduleBatchV2 = async (form: CreateScheduleBatchForm) => {
  const res = await client.post(`/v2/schedule/batch`, form);
  return res.data;
};

export const updateScheduleV2 = async (form: UpdateScheduleForm) => {
  const res = await client.put(`/v2/schedule/`, form);
  return res.data;
};

export const deleteScheduleV2 = async (form: DeleteScheduleForm) => {
  const res = await client.delete(`/v2/schedule/`, { data: form });
  return res.data;
};
